module.exports = __webpack_public_path__ + "img/pro2.1141a215.png";